function countAppts() {
	$("#appts").text($("#schedule input").length);
}

function addAppt(time) {
	appt = new Date(time).toString().split(" ");
	$("#schedule tr:last").after('<tr><td><input type="checkbox" checked="checked" id="schedule_" name="schedule[]" value="'+time.toUTCString()+'"> \
				'+time.toUTCString().substr(0,time.toUTCString().lastIndexOf(":"))+'</td></tr>');
}

function addslots() {
	reps = $("#numappts").val();
	dur = $("#duration").text();
	date = $("#day").val().split(",");
	year = parseInt(date[0]);
	month = parseInt(date[1])-1;
	day = parseInt(date[2]);
	hour = parseInt($("#hours").val());
	minute = parseInt($("#minutes").val());
	twice = $("#double").val() == 'true';
	pm = $("#ampm").val() == 'true';
	if (pm) {
		hour+=12;
	}
	apptime = new Date(Date.UTC(year, month, day, hour, minute));
	//alert("works: "+apptime+"\n"+hour);
	
	for (var k=0; k<reps; k++)
	{
		var a = new Date(apptime);
		var ts = new Date(a.setSeconds(k*(dur*60)));
		addAppt(ts);
		if (twice) 
		{
			addAppt(ts)
		}
	}
	$(countAppts);
	$("#step2").css("visibility", "visible");
}

$(document).ready(function() {
countAppts();
$("#submitappts").click(addslots);
});

